import { useModalStore } from '@/shared/lib';
import { PaidInvoicesModal } from '../ui';
import type { PaidInvoicesFormValues } from './types';

type Params = {
  onBack?: () => void;
  formValues?: PaidInvoicesFormValues;
  dateFrom?: Date;
  dateTo?: Date;
};

const usePaidInvoicesModal = () => {
  const { showDialogComponent } = useModalStore();

  const openPaidInvoicesModal = ({
    onBack,
    formValues,
    dateFrom,
    dateTo,
  }: Params = {}) => {
    showDialogComponent({
      component: (
        <PaidInvoicesModal
          onBack={onBack}
          formValues={formValues}
          dateFrom={dateFrom}
          dateTo={dateTo}
        />
      ),
    });
  };

  return { openPaidInvoicesModal };
};

export { usePaidInvoicesModal };
